export enum FieldType {
  Text = 1,
  Number = 2,
  YesNo = 3,
  Date = 4,
  ImageList = 5,
  Label = 6,
}
